var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-copy-1087201",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.81,
    height: 18.988,
    viewBox: "0 0 13.81 18.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M174.682,33.6a1.3,1.3,0,0,0-1.295,1.295v2.158h-1.295a1.3,1.3,0,0,0-1.295,1.295V51.294a1.3,1.3,0,0,0,1.295,1.295h8.631a1.3,1.3,0,0,0,1.295-1.295V49.136h1.295a1.3,1.3,0,0,0,1.295-1.295V37.915a.431.431,0,0,0-.128-.3L180.6,33.728a.432.432,0,0,0-.3-.128h-3.884a.432.432,0,1,0,0,.863h3.453v3.453a.432.432,0,0,0,.432.432h3.453v9.494a.421.421,0,0,1-.432.432h-8.631a.422.422,0,0,1-.432-.432V34.894a.422.422,0,0,1,.432-.432.432.432,0,1,0,0-.863Zm6.042,1.47,2.414,2.414h-2.414Zm-8.631,2.846h1.295v9.926a1.3,1.3,0,0,0,1.295,1.295h6.473v2.158a.422.422,0,0,1-.432.432h-8.631a.421.421,0,0,1-.432-.432V38.347a.421.421,0,0,1,.432-.432Z",
    transform: "translate(-170.798 -33.6)",
    fill: "#f37320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e48eefc61d299f9617d968c8b69a2a69.svg";
export { ForwardRef as ReactComponent };